import type * as Jimp from 'jimp';

const lumR: number[] = [];
const lumG: number[] = [];
const lumB: number[] = [];

// eslint-disable-next-line no-plusplus
for (let i = 0; i < 256; i++) {
  lumR[i] = i * 0.299;
  lumG[i] = i * 0.587;
  lumB[i] = i * 0.114;
}

// Mutate image data to be dithered using the Bill Atkinson dithering algorithm
function billAtkinsonDither(imageData: Jimp['bitmap'], threshold: number = 127) {
  const imageDataLength = imageData.data.length;

  // Grayscale luminance (sets r pixels to luminance of rgb)
  for (let i = 0; i <= imageDataLength; i += 4) {
    imageData.data[i] = Math.floor(
      // @ts-expect-error tested
      lumR[imageData.data[i]] + lumG[imageData.data[i + 1]] + lumB[imageData.data[i + 2]],
    );
  }

  const { width } = imageData;
  let newPixel;
  let err;

  for (let currentPixel = 0; currentPixel <= imageDataLength; currentPixel += 4) {
    // Bill Atkinson's dithering algorithm
    const currentPixelData = imageData.data[currentPixel] || 0;
    newPixel = currentPixelData < threshold ? 0 : 255;
    err = Math.floor((currentPixelData - newPixel) / 8);
    imageData.data[currentPixel] = newPixel;

    imageData.data[currentPixel + 4] += err;
    imageData.data[currentPixel + 8] += err;
    imageData.data[currentPixel + 4 * width - 4] += err;
    imageData.data[currentPixel + 4 * width] += err;
    imageData.data[currentPixel + 4 * width + 4] += err;
    imageData.data[currentPixel + 8 * width] += err;

    // Set g and b pixels equal to r
    imageData.data[currentPixel + 2] = imageData.data[currentPixel]!;
    imageData.data[currentPixel + 1] = imageData.data[currentPixel + 2]!;
  }

  return imageData;
}

export default billAtkinsonDither;
